jQuery(document).ready(function($) {

    /*
    $( "h2" ).each(function( index ) {

        var cibleH2 = $(this)

        var splitWordsH2 = new SplitText(cibleH2, {
            type: "words",
            tag:'div',
            reduceWhiteSpace:true,
            wordsClass: "word++"
        })

        var splitCharsH2 = new SplitText(cibleH2, {
            type: "chars",
            tag:'span',
            reduceWhiteSpace:true,
            mask: "chars",
            charsClass: "char++"
        })

        gsap.from(splitCharsH2.chars, {
            x:100,
            duration: 1.0,
            stagger: .005,
            ease: "power1.out",
            scrollTrigger: {
                trigger: cibleH2,
                markers: false,
                start: "top bottom"
            }

        });

    })
    */
});